import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import Highlighter from "react-highlight-words"
import cc from "classcat"
import useTranslations from "hooks/useTranslations"
import Divided from "components/organisms/common/Divided"

const BoyImage = ({ className }) => {
  const images = useStaticQuery(graphql`
    {
      boyImage: file(
        relativePath: { eq: "schools/AdobeStock_355903609.jpeg" }
      ) {
        childImageSharp {
          gatsbyImageData(quality: 90, width: 600)
        }
      }
    }
  `)

  return (
    <GatsbyImage
      image={getImage(images.boyImage)}
      imgStyle={{
        objectFit: "cover",
        objectPosition: "center",
      }}
      className={className}
    />
  )
}

const Text = ({ className, children }) => (
  <p
    className={cc([
      "m-0 whitespace-pre-line text-left font-display text-2xl text-zinc-800 sm:text-2xl",
      className,
    ])}
  >
    {children}
  </p>
)

const SmallText = ({ className, children }) => (
  <p
    className={cc([
      "m-0 whitespace-pre-line text-left text-base text-zinc-800",
      className,
    ])}
  >
    {children}
  </p>
)

export default function InfoBoy() {
  const {
    schoolsInfo1Title,
    schoolsInfo1Text,
    schoolsInfo1Highlight,
    schoolsInfo1SmallText,
  } = useTranslations()
  return (
    <Divided Image={BoyImage} title={schoolsInfo1Title} theme="green">
      <div>
        <Text>
          <Highlighter
            highlightClassName="text-white bg-transparent"
            searchWords={schoolsInfo1Highlight || [""]}
            autoEscape
            textToHighlight={schoolsInfo1Text}
          />
        </Text>
        <SmallText className="mt-8 lg:mt-16">{schoolsInfo1SmallText}</SmallText>
      </div>
    </Divided>
  )
}
